import React from 'react';
import { Business } from '../../../types/graphql';

interface PartnerInfoProps {
  partner: Pick<Business, 
    | 'contactName'
    | 'contactLastName'
    | 'contactPhone'
    | 'contactPosition'
    | 'email'
    | 'website'
    | 'address'
    | 'city'
    | 'country'
    | 'description'
  >;
}

export default function PartnerInfo({ partner }: PartnerInfoProps) {
  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-xl font-bold mb-6">Informations du partenaire</h2>
      
      <div className="grid grid-cols-2 gap-8">
        <div>
          <h3 className="font-medium text-gray-700 mb-4">Contact principal</h3>
          <dl className="space-y-2">
            <div>
              <dt className="text-sm text-gray-500">Nom</dt>
              <dd className="text-sm font-medium">{`${partner.contactName} ${partner.contactLastName}`}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-500">Position</dt>
              <dd className="text-sm font-medium">{partner.contactPosition}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-500">Email</dt>
              <dd className="text-sm font-medium">{partner.email}</dd>
            </div>
            <div>
              <dt className="text-sm text-gray-500">Téléphone</dt>
              <dd className="text-sm font-medium">{partner.contactPhone}</dd>
            </div>
          </dl>
        </div>

        <div>
          <h3 className="font-medium text-gray-700 mb-4">Adresse</h3>
          <address className="not-italic">
            <p className="text-sm">{partner.address}</p>
            <p className="text-sm">{partner.city}</p>
            <p className="text-sm">{partner.country}</p>
          </address>
        </div>
      </div>
    </div>
  );
}